/* eslint-disable max-len */
import moment from 'moment';
import Api from '../../services/Api';

const defaultConfig = {
  selectedRangeOfDays: 1,
  selectedMeasuringFrequency: 'RAW',
  rangeOfDays: ['1', '7', '10', '14'],
  measuringFrequency: ['RAW', 'HOURLY', 'DAILY'],
};

export default {
  namespaced: true,
  state: {
    weatherForecastedDataByLocations: [],
    weatherMeasuredDataByLocations: [],
    rangeOfDays: defaultConfig.rangeOfDays,
    selectedRangeOfDays: defaultConfig.selectedRangeOfDays,
    measuringFrequency: defaultConfig.measuringFrequency,
    selectedMeasuringFrequency: defaultConfig.selectedMeasuringFrequency,
    selectedFarmID: '',
  },
  getters: {
    hourlyMeasuredTemperatures(state) {
      const locationMeasuredTemperatures = state.weatherMeasuredDataByLocations
        .filter(
          (weatherMeasuredDataLocation) => weatherMeasuredDataLocation.location === state.selectedFarmID,
        );
      let temperaturaAriaMedia = [];
      if (locationMeasuredTemperatures[0].parameters.TEMPERATURE_AVG) {
        temperaturaAriaMedia = locationMeasuredTemperatures[0].parameters.TEMPERATURE_AVG.temperaturaAriaMedia;
      }
      let temperaturaAriaMin = [];
      if (locationMeasuredTemperatures[0].parameters.TEMPERATURE_MIN) {
        temperaturaAriaMin = locationMeasuredTemperatures[0].parameters.TEMPERATURE_MIN.temperaturaAriaMin;
      }
      let temperaturaAriaMax = [];
      if (locationMeasuredTemperatures[0].parameters.TEMPERATURE_MAX) {
        temperaturaAriaMax = locationMeasuredTemperatures[0].parameters.TEMPERATURE_MAX.temperaturaAriaMax;
      }
      const hourlyMeasuredTemperatures = [];

      for (let i = 0; i < temperaturaAriaMedia.length; i += 1) {
        hourlyMeasuredTemperatures.push({
          minTemp: temperaturaAriaMin[i].value,
          maxTemp: temperaturaAriaMax[i].value,
          measuredTemperature: temperaturaAriaMedia[i].value,
          date: temperaturaAriaMedia[i].date,
        });
      }

      return hourlyMeasuredTemperatures;
    },
    hourlyForecastedTemperatures(state) {
      const locationForecastedTemperatures = state.weatherForecastedDataByLocations
        .filter(
          (weatherForecastedDataLocation) => weatherForecastedDataLocation.location === state.selectedFarmID,
        );

      const { temperature } = locationForecastedTemperatures[0].parameters.TEMPERATURE;
      const hourlyForecastedTemperature = [];
      for (let i = 0; i < temperature.length; i += 1) {
        hourlyForecastedTemperature.push({
          forecastedTemperature: temperature[i].value,
          date: temperature[i].date,
        });
      }
      return hourlyForecastedTemperature;
    },
    dailyMeasuredTemperatures(state) {
      const locationMeasuredTemperatures = state.weatherMeasuredDataByLocations
        .filter(
          (weatherMeasuredDataLocation) => weatherMeasuredDataLocation.location === state.selectedFarmID,
        );
      let temperaturaAriaMedia = [];
      if (locationMeasuredTemperatures[0].parameters.TEMPERATURE_AVG) {
        temperaturaAriaMedia = locationMeasuredTemperatures[0].parameters.TEMPERATURE_AVG.temperaturaAriaMedia;
      }
      const dailyMeasuredTemperaturesAVG = [];
      const averageDatesDone = [];

      const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

      temperaturaAriaMedia.forEach((measuredTemperatureAVG) => {
        const date = measuredTemperatureAVG.date.split(' ')[0];

        if (averageDatesDone.indexOf(date) === -1) {
          averageDatesDone.push(date);
          const currentDayTemperaturesAVG = temperaturaAriaMedia
            .filter((temperature) => date === temperature.date.split(' ')[0]);

          const currentDayTemperaturesAVGValues = currentDayTemperaturesAVG
            .map((currentDayTemperature) => currentDayTemperature.value);

          const totalTemperaturesAVG = currentDayTemperaturesAVGValues.reduce(sumReducer);

          const average = totalTemperaturesAVG / currentDayTemperaturesAVGValues.length;

          dailyMeasuredTemperaturesAVG.push({ date, unit: 'celsius', value: average });
        }
      });
      let temperaturaAriaMin = [];
      if (locationMeasuredTemperatures[0].parameters.TEMPERATURE_MIN) {
        temperaturaAriaMin = locationMeasuredTemperatures[0].parameters.TEMPERATURE_MIN.temperaturaAriaMin;
      }
      const dailyMeasuredTemperaturesMIN = [];
      const minDatesDone = [];

      temperaturaAriaMin.forEach((measuredTemperatureMIN) => {
        const date = measuredTemperatureMIN.date.split(' ')[0];

        if (minDatesDone.indexOf(date) === -1) {
          minDatesDone.push(date);
          const currentDayTemperaturesMIN = temperaturaAriaMin
            .filter((temperature) => date === temperature.date.split(' ')[0]);

          const currentDayTemperaturesMINValues = currentDayTemperaturesMIN
            .map((currentDayTemperature) => currentDayTemperature.value);

          const min = Math.min(...currentDayTemperaturesMINValues);

          dailyMeasuredTemperaturesMIN.push({ date, unit: 'celsius', value: min });
        }
      });
      let temperaturaAriaMax = [];
      if (locationMeasuredTemperatures[0].parameters.TEMPERATURE_MAX) {
        temperaturaAriaMax = locationMeasuredTemperatures[0].parameters.TEMPERATURE_MAX.temperaturaAriaMax;
      }
      const dailyMeasuredTemperaturesMAX = [];
      const maxDatesDone = [];

      temperaturaAriaMax.forEach((measuredTemperatureMAX) => {
        const date = measuredTemperatureMAX.date.split(' ')[0];

        if (maxDatesDone.indexOf(date) === -1) {
          maxDatesDone.push(date);
          const currentDayTemperaturesMAX = temperaturaAriaMin
            .filter((temperature) => date === temperature.date.split(' ')[0]);

          const currentDayTemperaturesMAXValues = currentDayTemperaturesMAX
            .map((currentDayTemperature) => currentDayTemperature.value);

          const max = Math.max(...currentDayTemperaturesMAXValues);

          dailyMeasuredTemperaturesMAX.push({ date, unit: 'celsius', value: max });
        }
      });

      const dailyMeasuredTemperatures = [];

      for (let i = 0; i < dailyMeasuredTemperaturesAVG.length; i += 1) {
        dailyMeasuredTemperatures.push({
          minTemp: dailyMeasuredTemperaturesMIN[i].value,
          maxTemp: dailyMeasuredTemperaturesMAX[i].value,
          measuredTemperature: dailyMeasuredTemperaturesAVG[i].value,
          date: dailyMeasuredTemperaturesAVG[i].date,
        });
      }

      return dailyMeasuredTemperatures;
    },
    dailyForecastedTemperatures(state) {
      const locationForecastedTemperatures = state.weatherForecastedDataByLocations
        .filter(
          (weatherForecastedDataLocation) => weatherForecastedDataLocation.location === state.selectedFarmID,
        );
      const temperatures = locationForecastedTemperatures[0].parameters.TEMPERATURE.temperature;

      const dailyForecastedTemperaturesAVG = [];
      const dailyForecastedTemperaturesMIN = [];
      const dailyForecastedTemperaturesMAX = [];
      const datesDone = [];

      const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

      temperatures.forEach((temperatureData) => {
        const date = temperatureData.date.split(' ')[0];

        if (datesDone.indexOf(date) === -1) {
          datesDone.push(date);

          const currentDayTemperatures = temperatures
            .filter((temperature) => date === temperature.date.split(' ')[0]);

          const currentDayTemperaturesValues = currentDayTemperatures
            .map((currentDayTemperature) => currentDayTemperature.value);

          const totalTemperaturesAVG = currentDayTemperaturesValues.reduce(sumReducer);

          const avg = totalTemperaturesAVG / currentDayTemperaturesValues.length;

          const min = Math.min(...currentDayTemperaturesValues);
          const max = Math.max(...currentDayTemperaturesValues);

          dailyForecastedTemperaturesAVG.push({ date, unit: 'celsius', value: avg });
          dailyForecastedTemperaturesMIN.push({ date, unit: 'celsius', value: min });
          dailyForecastedTemperaturesMAX.push({ date, unit: 'celsius', value: max });
        }
      });
      const dailyForecastedTemperatures = [];

      for (let i = 0; i < dailyForecastedTemperaturesAVG.length; i += 1) {
        dailyForecastedTemperatures.push({
          minTemp: dailyForecastedTemperaturesMIN[i].value,
          maxTemp: dailyForecastedTemperaturesMAX[i].value,
          forecastedTemperature: dailyForecastedTemperaturesAVG[i].value,
          date: dailyForecastedTemperaturesAVG[i].date,
        });
      }

      return dailyForecastedTemperatures;
    },
    hourlyMeasuredHumidities(state) {
      const locationMeasuredHumidities = state.weatherMeasuredDataByLocations
        .filter(
          (weatherMeasuredDataLocation) => weatherMeasuredDataLocation.location === state.selectedFarmID,
        );
      let hourlyMeasuredHumiditiesAVG = [];
      if (locationMeasuredHumidities[0].parameters.HUMIDITY_AVG) {
        hourlyMeasuredHumiditiesAVG = locationMeasuredHumidities[0].parameters.HUMIDITY_AVG.umiditaRelativaMedia;
      }
      let hourlyMeasuredHumiditiesMAX = [];
      if (locationMeasuredHumidities[0].parameters.HUMIDITY_MAX) {
        hourlyMeasuredHumiditiesMAX = locationMeasuredHumidities[0].parameters.HUMIDITY_MAX.umiditaRelativaMax;
      }
      let hourlyMeasuredHumiditiesMIN = [];
      if (locationMeasuredHumidities[0].parameters.HUMIDITY_MIN) {
        hourlyMeasuredHumiditiesMIN = locationMeasuredHumidities[0].parameters.HUMIDITY_MIN.umiditaRelativaMin;
      }

      const hourlyMeasuredHumidities = [];
      for (let i = 0; i < hourlyMeasuredHumiditiesAVG.length; i += 1) {
        hourlyMeasuredHumidities.push({
          minTemp: hourlyMeasuredHumiditiesMIN[i].value,
          maxTemp: hourlyMeasuredHumiditiesMAX[i].value,
          measuredHumidity: hourlyMeasuredHumiditiesAVG[i].value,
          date: hourlyMeasuredHumiditiesAVG[i].date,
        });
      }
      return hourlyMeasuredHumidities;
    },
    hourlyForecastedHumidities(state) {
      const locationForecastedHumidities = state.weatherForecastedDataByLocations
        .filter(
          (weatherForecastedDataLocation) => weatherForecastedDataLocation.location === state.selectedFarmID,
        );

      const { humidity } = locationForecastedHumidities[0].parameters.HUMIDITY;
      const hourlyForecastedHumidity = [];
      for (let i = 0; i < humidity.length; i += 1) {
        hourlyForecastedHumidity.push({
          forecastedHumidity: humidity[i].value,
          date: humidity[i].date,
        });
      }
      return hourlyForecastedHumidity;
    },
    dailyMeasuredHumidities(state) {
      const locationMeasuredHumidities = state.weatherMeasuredDataByLocations
        .filter(
          (weatherMeasuredDataLocation) => weatherMeasuredDataLocation.location === state.selectedFarmID,
        );
      let umiditaRelativaMedia = [];
      if (locationMeasuredHumidities[0].parameters.HUMIDITY_AVG) {
        umiditaRelativaMedia = locationMeasuredHumidities[0].parameters.HUMIDITY_AVG.umiditaRelativaMedia;
      }
      const dailyMeasuredHumiditiesAVG = [];
      const averageDatesDone = [];

      const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

      umiditaRelativaMedia.forEach((measuredHumidityAVG) => {
        const date = measuredHumidityAVG.date.split(' ')[0];

        if (averageDatesDone.indexOf(date) === -1) {
          averageDatesDone.push(date);
          const currentDayHumiditiesAVG = umiditaRelativaMedia
            .filter((humidity) => date === humidity.date.split(' ')[0]);

          const currentDayHumidityAVGValues = currentDayHumiditiesAVG
            .map((currentDayHumidity) => currentDayHumidity.value);

          const totalHumiditiesAVG = currentDayHumidityAVGValues.reduce(sumReducer);

          const average = totalHumiditiesAVG / currentDayHumidityAVGValues.length;

          dailyMeasuredHumiditiesAVG.push({ date, unit: 'percentage', value: average });
        }
      });
      let umiditaRelativaMin = [];
      if (locationMeasuredHumidities[0].parameters.HUMIDITY_MIN) {
        umiditaRelativaMin = locationMeasuredHumidities[0].parameters.HUMIDITY_MIN.umiditaRelativaMin;
      }
      const dailyMeasuredHumiditiesMIN = [];
      const minDatesDone = [];

      umiditaRelativaMin.forEach((measuredHumidityMIN) => {
        const date = measuredHumidityMIN.date.split(' ')[0];

        if (minDatesDone.indexOf(date) === -1) {
          minDatesDone.push(date);
          const currentDayHumiditiesMIN = umiditaRelativaMin
            .filter((humidity) => date === humidity.date.split(' ')[0]);

          const currentDayHumiditiesMINValues = currentDayHumiditiesMIN
            .map((currentDayHumidity) => currentDayHumidity.value);

          const min = Math.min(...currentDayHumiditiesMINValues);

          dailyMeasuredHumiditiesMIN.push({ date, unit: 'percentage', value: min });
        }
      });
      let umiditaRelativaMax = [];
      if (locationMeasuredHumidities[0].parameters.HUMIDITY_MAX) {
        umiditaRelativaMax = locationMeasuredHumidities[0].parameters.HUMIDITY_MAX.umiditaRelativaMax;
      }
      const dailyMeasuredHumiditiesMAX = [];
      const maxDatesDone = [];

      umiditaRelativaMax.forEach((measuredHumidityMAX) => {
        const date = measuredHumidityMAX.date.split(' ')[0];

        if (maxDatesDone.indexOf(date) === -1) {
          maxDatesDone.push(date);
          const currentDayHumiditiesMAX = umiditaRelativaMax
            .filter((humidity) => date === humidity.date.split(' ')[0]);

          const currentDayHumiditiesMAXValues = currentDayHumiditiesMAX
            .map((currentDayHumidity) => currentDayHumidity.value);

          const max = Math.max(...currentDayHumiditiesMAXValues);

          dailyMeasuredHumiditiesMAX.push({ date, unit: 'celsius', value: max });
        }
      });
      const dailyMeasuredHumidities = [];

      for (let i = 0; i < dailyMeasuredHumiditiesAVG.length; i += 1) {
        dailyMeasuredHumidities.push({
          minTemp: dailyMeasuredHumiditiesMIN[i].value,
          maxTemp: dailyMeasuredHumiditiesMAX[i].value,
          measuredHumidity: dailyMeasuredHumiditiesAVG[i].value,
          date: dailyMeasuredHumiditiesAVG[i].date,
        });
      }
      return dailyMeasuredHumidities;
    },
    dailyForecastedHumidities(state) {
      const locationForecastedHumidities = state.weatherForecastedDataByLocations
        .filter(
          (weatherForecastedDataLocation) => weatherForecastedDataLocation.location === state.selectedFarmID,
        );
      const humidities = locationForecastedHumidities[0].parameters.HUMIDITY.humidity;

      const dailyForecastedHumiditiesAVG = [];
      const dailyForecastedHumiditiesMIN = [];
      const dailyForecastedHumiditiesMAX = [];
      const datesDone = [];

      const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

      humidities.forEach((humidityData) => {
        const date = humidityData.date.split(' ')[0];

        if (datesDone.indexOf(date) === -1) {
          datesDone.push(date);

          const currentDayHumidities = humidities
            .filter((humidity) => date === humidity.date.split(' ')[0]);

          const currentDayHumiditiesValues = currentDayHumidities
            .map((currentDayHumidity) => currentDayHumidity.value);

          const totalHumiditiesAVG = currentDayHumiditiesValues.reduce(sumReducer);

          const avg = totalHumiditiesAVG / currentDayHumiditiesValues.length;

          const min = Math.min(...currentDayHumiditiesValues);
          const max = Math.max(...currentDayHumiditiesValues);

          dailyForecastedHumiditiesAVG.push({ date, unit: 'percentage', value: avg });
          dailyForecastedHumiditiesMIN.push({ date, unit: 'percentage', value: min });
          dailyForecastedHumiditiesMAX.push({ date, unit: 'percentage', value: max });
        }
      });
      const dailyForecastedHumidities = [];

      for (let i = 0; i < dailyForecastedHumiditiesAVG.length; i += 1) {
        dailyForecastedHumidities.push({
          minTemp: dailyForecastedHumiditiesMIN[i].value,
          maxTemp: dailyForecastedHumiditiesMAX[i].value,
          forecastedHumidity: dailyForecastedHumiditiesAVG[i].value,
          date: dailyForecastedHumiditiesAVG[i].date,
        });
      }
      return dailyForecastedHumidities;
    },
    hourlyMeasuredPrecipitations(state) {
      const locationMeasuredPrecipitations = state.weatherMeasuredDataByLocations
        .filter(
          (weatherMeasuredDataLocation) => weatherMeasuredDataLocation.location === state.selectedFarmID,
        );
      let pioggia = [];
      if (locationMeasuredPrecipitations[0].parameters.PLUVIOMETER) {
        pioggia = locationMeasuredPrecipitations[0].parameters.PLUVIOMETER.pioggia;
      }
      const measuredPrecipitations = [];

      pioggia.forEach((precipitation) => {
        measuredPrecipitations.push({
          measuredPrecipitation: precipitation.value,
          date: precipitation.date,
        });
      });
      return measuredPrecipitations;
    },
    hourlyForecastedPrecipitations(state) {
      const locationForecastedPrecipitations = state.weatherForecastedDataByLocations
        .filter(
          (weatherForecastedDataLocation) => weatherForecastedDataLocation.location === state.selectedFarmID,
        );

      const { precipIntensity } = locationForecastedPrecipitations[0].parameters.PLUVIOMETER;
      const forecastedPrecipitations = [];

      precipIntensity.forEach((precipitation) => {
        forecastedPrecipitations.push({
          forecastedPrecipitation: precipitation.value,
          date: precipitation.date,
        });
      });
      return forecastedPrecipitations;
    },
    dailyMeasuredPrecipitations(state) {
      const locationMeasuredPrecipitations = state.weatherMeasuredDataByLocations
        .filter(
          (weatherMeasuredDataLocation) => weatherMeasuredDataLocation.location === state.selectedFarmID,
        );
      let measuredPrecipitations = [];
      if (locationMeasuredPrecipitations[0].parameters.PLUVIOMETER) {
        measuredPrecipitations = locationMeasuredPrecipitations[0].parameters.PLUVIOMETER.pioggia;
      }
      const dailyMeasuredPrecipitations = [];
      const datesDone = [];
      const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

      measuredPrecipitations.forEach((precipitationData) => {
        const date = precipitationData.date.split(' ')[0];

        if (datesDone.indexOf(date) === -1) {
          datesDone.push(date);
          const currentDayPrecipitations = measuredPrecipitations
            .filter((precipitation) => date === precipitation.date.split(' ')[0]);

          const currentDayPrecipitationsValues = currentDayPrecipitations
            .map((currentDayHumidity) => currentDayHumidity.value);

          const totalPrecipitations = currentDayPrecipitationsValues.reduce(sumReducer);

          dailyMeasuredPrecipitations.push({ date, measuredPrecipitation: totalPrecipitations });
        }
      });
      return dailyMeasuredPrecipitations;
    },
    dailyForecastedPrecipitations(state) {
      const locationForecastedPrecipitations = state.weatherForecastedDataByLocations
        .filter(
          (weatherForecastedDataLocation) => weatherForecastedDataLocation.location === state.selectedFarmID,
        );
      const forecastedPrecipitations = locationForecastedPrecipitations[0].parameters.PLUVIOMETER.precipIntensity;

      const dailyForecastedPrecipitations = [];
      const datesDone = [];
      const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

      forecastedPrecipitations.forEach((precipitationData) => {
        const date = precipitationData.date.split(' ')[0];

        if (datesDone.indexOf(date) === -1) {
          datesDone.push(date);
          const currentDayPrecipitations = forecastedPrecipitations
            .filter((precipitation) => date === precipitation.date.split(' ')[0]);

          const currentDayPrecipitationsValues = currentDayPrecipitations
            .map((currentDayPrecipitation) => currentDayPrecipitation.value);

          const totalPrecipitations = currentDayPrecipitationsValues.reduce(sumReducer);

          dailyForecastedPrecipitations.push({ date, forecastedPrecipitation: totalPrecipitations });
        }
      });
      return dailyForecastedPrecipitations;
    },
  },

  mutations: {
    SET_WEATHER_FORECAST_DATA(state, payload) {
      state.weatherForecastedDataByLocations = payload;
    },
    SET_WEATHER_MEASURED_DATA(state, payload) {
      state.weatherMeasuredDataByLocations = payload;
    },
    SET_SELECTED_FARM_ID(state, payload) {
      state.selectedFarmID = payload;
    },
    SET_SELECTED_MEASURING_FREQUENCY(state, payload) {
      state.selectedMeasuringFrequency = payload;
    },
  },
  actions: {
    async fetchWeatherForecastData({ commit, rootGetters }, locations) {
      const { climateGrids } = rootGetters['CalendarInitEndDate/actualFilter'];
      let formattedInit = '';
      let formattedEnd = '';
      if ((typeof climateGrids === 'undefined')) {
        formattedInit = moment.utc().subtract(1, 'd').format('YYYY-MM-DDT00:00:00');
        formattedEnd = moment.utc().add(1, 'd').format('YYYY-MM-DDT23:59:59');
      } else {
        const { init, end } = climateGrids;
        formattedInit = moment(init).format('YYYY-MM-DDT00:00:00');
        formattedEnd = moment(end).format('YYYY-MM-DDT23:59:59');
      }
      try {
        const forecasts = await Api.getClimate(locations, 'FORECAST', formattedInit, formattedEnd, ['TEMPERATURE', 'PLUVIOMETER', 'HUMIDITY'], true);
        commit('SET_WEATHER_FORECAST_DATA', JSON.parse(forecasts.response));
        Promise.resolve();
      } catch (error) {
        Promise.reject(error);
      }
    },
    async fetchMeasuredWeatherData({ commit, rootGetters }, locations) {
      const { climateGrids } = rootGetters['CalendarInitEndDate/actualFilter'];
      let formattedInit = '';
      let formattedEnd = '';
      if ((typeof climateGrids === 'undefined')) {
        formattedInit = moment.utc().subtract(1, 'd').format('YYYY-MM-DDT00:00:00');
        formattedEnd = moment.utc().add(1, 'd').format('YYYY-MM-DDT23:59:59');
      } else {
        const { init, end } = climateGrids;
        formattedInit = moment(init).format('YYYY-MM-DDT00:00:00');
        formattedEnd = moment(end).format('YYYY-MM-DDT23:59:59');
      }
      try {
        const measures = await Api.getClimate(locations, 'MEASURED', formattedInit, formattedEnd, ['TEMPERATURE_MIN', 'TEMPERATURE_MAX', 'TEMPERATURE_AVG', 'PLUVIOMETER', 'HUMIDITY_AVG'], true);
        commit('SET_WEATHER_MEASURED_DATA', JSON.parse(measures.response));
        Promise.resolve();
      } catch (error) {
        Promise.reject(error);
      }
    },
    setSelectedFarmID({ commit }, newSelectedFarmID) {
      commit('SET_SELECTED_FARM_ID', newSelectedFarmID);
    },
    setSelectedMeasuringFrequency({ commit }, newMeasuringFrequency) {
      commit('SET_SELECTED_MEASURING_FREQUENCY', newMeasuringFrequency);
    },
    setSelectedRangeOfDays({ commit }, newRangeOfDays) {
      commit('SET_SELECTED_RANGE_OF_DAYS', newRangeOfDays);
    },

  },
};
